import { render } from "./DeleteMessageConfirm.vue?vue&type=template&id=c352415a&lang=pug"
import script from "./DeleteMessageConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteMessageConfirm.vue?vue&type=script&lang=js"

import "./DeleteMessageConfirm.vue?vue&type=style&index=0&id=c352415a&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__